if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

// for popup while clicking on icon
let productZoomIcon = document.querySelector('#product-top .single-nav-img svg.customimagezoom');
productZoomIcon.addEventListener('click', function(e){
  e.preventDefault();

  let activeZoomIcon = this.closest('.single-nav-img').querySelector('.img_producto_container.is-selected a.fslightbox');
  activeZoomIcon.click();

})
// end

  // AJAX side cart for adding product to cart
  
  document.addEventListener('DOMContentLoaded', () => {
    const giftForm = document.querySelector('.product_mainform');
    const giftSubmitButton = giftForm?.querySelector('.add-to-cart-gift-form');
  
    if (!giftForm || !giftSubmitButton) return;
  
    giftForm.addEventListener('submit', (e) => {
      e.preventDefault();
  
      const formData = new FormData(giftForm);
  
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(data => {
          console.log('🛒 Gift item added:', data);
  
          return fetch('/?sections=cart-drawer,cart-icon-bubble', {
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to load cart sections');
          return response.json();
        })
        .then(sections => {
          const cartDrawer = document.querySelector('cart-drawer');
  
          if (cartDrawer?.renderContents) {
            cartDrawer.renderContents({
              id: Date.now(), // dummy ID for compatibility
              sections: sections
            });

            // Wait a bit for DOM to update (renderContents runs async tasks)
            setTimeout(() => {
              // Remove is-empty classes if cart items exist
              cartDrawer.classList.remove('is-empty');
              cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');

              // Hide empty message if it's still showing
              const emptyMessage = cartDrawer.querySelector('.drawer__inner-empty');
              if (emptyMessage) {
                emptyMessage.style.display = 'none';
              }

              // Show drawer inner if it’s hidden
              const drawerInner = cartDrawer.querySelector('.drawer__inner');
              if (drawerInner) {
                drawerInner.classList.remove('is-empty');
              }

              // Re-open the drawer in case it didn't trigger from renderContents
              cartDrawer.classList.add('active');
              document.body.classList.add('overflow-hidden');
            }, 50);

          } else {
            console.warn('🛑 cart-drawer element or renderContents() not available.');
          }
        })
        .catch(error => {
          console.error('❌ Error handling cart drawer update:', error);
        });
    });
  });
  

  
// End of AJAX side cat for adding product


// Get all the variant options (radio buttons and select dropdowns)
var variantRadioButtons = document.querySelectorAll('.variant-radio');
var variantSelects = document.querySelectorAll('.variant-option');

// Function to find the selected variant
function findSelectedVariant(variants, selectedValues) {
  // Convert the array of selected values into a comma-separated string
  const selectedValuesString = selectedValues.join(',');

  // Find the variant that matches the selected values
  const selectedVariant = variants.find(variant => {
    // Convert the array of variant options into a comma-separated string
    const variantOptionsString = variant.options.join(',');

    // Compare the variant's options with the selected values
    return variantOptionsString === selectedValuesString;
  });

  return selectedVariant;
}

const productVariants = window.productVariants;

// get all variant options (radio and select dropdowns)
const variantInputs = document.querySelectorAll('.variant-radio, .variant-option');

// Function to handle variant changes
// Function to handle variant changes
function handleVariantChange() {
  const selectedValues = [];
  const selectedOptions = {};
  const clickedRadio = this;

  // Helper function to add or remove active class for radio buttons
  function updateRadioButtonState() {
    variantRadioButtons.forEach(radio => {
      if (radio.checked) {
        selectedValues.push(radio.value);
        selectedOptions[radio.name] = radio.value;
      }
      const labels = clickedRadio.closest('.radio-option').querySelectorAll('div.pos_relative label');
      labels.forEach(label => label.classList.remove('active'));
      clickedRadio.closest('.pos_relative').querySelector('label').classList.add('active');
    });
  }

  // Helper function to add selected values from select dropdowns
  function updateSelectValues() {
    variantSelects.forEach(select => {
      selectedValues.push(select.value);
      selectedOptions[select.name] = select.value;
    });
  }

  // Helper function to update out-of-stock status for single-option products
  function handleSingleOption(variant, optionName) {
    if (variant.option1 === selectedOptions[optionName]) {
      const selector = `input.variant-radio.${CSS.escape(variant.option1.toLowerCase().trim())}[data-option-name="${optionName}"] + label`;
      const labelElement = document.querySelector(selector);
      if (labelElement && variant.inventory_quantity <= 0 && variant.inventory_policy === 'deny') {
        labelElement.classList.add('outofstock');
      }
    }
  }

  // Helper function to handle multiple options and update out-of-stock status
  function handleMultipleOptions(optionName) {
    const otherOptions = { ...selectedOptions };
    delete otherOptions[optionName];

    window.productVariants.forEach(variant => {
      const allOptions = Array.from(document.querySelectorAll(`input[data-option-name="${optionName}"]`)).map(radio => radio.value);

      allOptions.forEach(optionValue => {
        const combinedOptions = { ...selectedOptions, [optionName]: optionValue };

        if (Object.keys(combinedOptions).every((key, index) => variant[`option${index + 1}`] === combinedOptions[key])) {
          const selector = `input.variant-radio.${CSS.escape(optionValue.toLowerCase().trim())}[data-option-name="${optionName}"] + label`;
          const labelElement = document.querySelector(selector);
          if (labelElement && variant.inventory_quantity <= 0 && variant.inventory_policy === 'deny') {
            labelElement.classList.add('outofstock');
          }
        }
      });
    });
  }

  // Begin handling variant changes
  updateRadioButtonState();
  updateSelectValues();

  // Determine if product has one or multiple options
  const isSingleOption = window.productVariants[0].options.length === 1;

  if (isSingleOption) {
    const optionName = window.productVariants[0].options[0];
    window.productVariants.forEach(variant => handleSingleOption(variant, optionName));
  } else {
      // Clear out-of-stock status before checking variant availability
    document.querySelectorAll('.radio-option label').forEach(label => label.classList.remove('outofstock'));
    Object.keys(selectedOptions).forEach(optionName => handleMultipleOptions(optionName));
  }

  // Find and handle the selected variant
  const selectedVariant = findSelectedVariant(window.productVariants, selectedValues);

  if (selectedVariant) {
    const $form = this.closest(".globalatc"),
          $hiddenInput = $form.querySelector("form input.hiddenform"),
          $quantityInput = document.querySelector(".product-form__buttons input.quntityInput"),
          variantNewPrice = $form.querySelector(".price_diff .formattedMainPrice"),
          variantCent = $form.querySelector(".price_diff .formattedCentsPrice"),
          variantOldPrice = $form.querySelector("span.js-old-price"),
          percentOff = $form.querySelectorAll(".js-percent-off");
  
    let $addButton = document.querySelector(".product-form__buttons button.addToCartBtn");
    if (!$addButton) {
      $addButton = document.querySelector(".add-to-cart-gift-form");
    }
  
    const inventory_quantity = selectedVariant.inventory_quantity,
          inventory_policy = selectedVariant.inventory_policy,
          $addButtonStatus = inventory_quantity > 0 || inventory_policy !== 'deny',
          $afterpay = $form.querySelector("span.js-afterpay-payments"),
          $priceDiff = $form.querySelector("span.js-save");
  
    addToCartButton($addButton, $addButtonStatus, selectedVariant);
    updateURL(selectedVariant);
  
    if ($hiddenInput) updateHiddenInput(selectedVariant, $hiddenInput);
  
    const updateButtonFrom = document.querySelector('form.buttonproduct input.product-variant-id');
    if (updateButtonFrom) {
      updateButtonFrom.setAttribute("value", selectedVariant.id);
    }
  
    if ($quantityInput) {
      setQuantityInputValue(selectedVariant, $quantityInput);
    }
  
    if (variantNewPrice && variantCent && variantOldPrice && percentOff && $afterpay && $priceDiff) {
      changePrice(selectedVariant, variantNewPrice, variantCent, variantOldPrice, percentOff, $afterpay, $priceDiff);
    }
  
    hideCompareAtPriceElement(selectedVariant);
    updateMedia(selectedVariant);
  
    if (selectedVariant.option2 != null) {
      const colorName = $form.querySelector('.js-color-name');
      if (colorName) colorName.innerHTML = selectedVariant.option2;
    }
  
    console.log('Selected Variant', selectedVariant);
  }
  

}



  // Add event listeners to radio buttons
  variantRadioButtons.forEach(function(radio) {
    radio.addEventListener('click', handleVariantChange);
  });

  // Add event listeners to select dropdowns
  variantSelects.forEach(function(select) {
    select.addEventListener('change', handleVariantChange);
  });

function hideCompareAtPriceElement(selectedVariant) {
  if (selectedVariant.compare_at_price <= 0) {
    document.querySelector('.product-action').classList.add('hide_compare_at');
  }else{
    document.querySelector('.product-action').classList.remove('hide_compare_at');
  }
}

function addToCartButton($addButton, $addButtonStatus, selectedVariant) {
  if (!$addButton) return; // early exit if button doesn't exist

  $addButton.disabled = !$addButtonStatus;

  if ($addButton.hasAttribute('disabled')) {
    $addButton.classList.add('disabled');
    $addButton.classList.remove('preorder');
    const span = $addButton.querySelector('span');
    if (span) span.innerHTML = "Sold Out";
    return;
  }

  $addButton.classList.remove('disabled');

  if (selectedVariant.inventory_policy === 'continue' &&
      selectedVariant.inventory_quantity <= 0 &&
      selectedVariant.tags.includes("preorder")) {
    const span = $addButton.querySelector('span');
    if (span) span.innerHTML = "Pre Order";
    $addButton.classList.add('preorder');
    return;
  }

  $addButton.classList.remove('preorder');
  const span = $addButton.querySelector('span');
  if (span) span.innerHTML = "Add to Cart";
}

function updateURL(selectedVariant) {
    window.history.replaceState(null, null, `?variant=${selectedVariant.id}`);
}

function updateHiddenInput(selectedVariant, $hiddenInput) {
    $hiddenInput.value = selectedVariant.id;
    let updateButtonFrom = document.querySelector('form.buttonproduct input.product-variant-id');
    if (updateButtonFrom) {
      updateButtonFrom.setAttribute("value", selectedVariant.id);
    }
}

function setQuantityInputValue(selectedVariant, $quantityInput) {
    $quantityInput.value = 1;

    var setUpdatedQuantity = selectedVariant.inventory_quantity;
    if(setUpdatedQuantity <= 0 && selectedVariant.inventory_policy === 'continue'){
      setUpdatedQuantity = 12;
    }
  
    $quantityInput.setAttribute("max", setUpdatedQuantity);
}

var flkty;

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Flickity
  flkty = new Flickity('.product__image-slider',{
    // Flickity options
    contain: true,
    wrapAround: true,
    pageDots: false
  })
})

function updateMedia(selectedVariant) {
    if (!selectedVariant) return;
    if (!selectedVariant.featured_media) return;
    var current_media_id = selectedVariant.featured_media.id;
  
    // For product page with flickity
    if (document.querySelector('.product__image-slider')) {
  
      var media_len = document.querySelector('.product__image-slider .flickity-slider').childElementCount;
      
      var media_id_array = [];
      for (let i = 0; i < media_len; i++) {
        
        media_id_array.push(parseInt(document.querySelector('.product__image-slider').querySelectorAll("img")[i].getAttribute('data-media-id')));
      }
      flkty.select(media_id_array.indexOf(current_media_id));
    }
    // For featured products on homepage without flickity
    else if (document.querySelector('.product__media-list')) {
      var featured_product_media_len = document.querySelector('.product__media-list').childElementCount;
      for (let i = 0; i < featured_product_media_len; i++) {
        var child = document.querySelector('.product__media-list').children[i];
        if (child.getAttribute('data-media-id').indexOf(current_media_id) > 0) {
          child.style.display = "block";
        } else {
          child.style.display = "none";
        }
      }
    }
  } 

function changePrice(selectedVariant, variantNewPrice, variantCent, variantOldPrice, percentOff, $afterpay, $priceDiff) {
  var globalProductVariantPrice = 0,
      globalProductOldPrice = 0;

    if ((selectedVariant.price / 100) % 1 === 0) {
      globalProductVariantPrice = ((selectedVariant.price)/100).toFixed(0);
      variantNewPrice.innerHTML = globalProductVariantPrice;

      variantCent.style.display = 'none';

    }else{
      globalProductVariantPrice = ((selectedVariant.price)/100).toFixed(2);

      variantCent.style.display = 'block';

      // Convert the number to a string
      const numberString = globalProductVariantPrice.toString();
      // Find the index of the decimal point
      const decimalIndex = numberString.indexOf('.');
      // Extract the substring after the decimal point
      const digitsAfterDecimal = numberString.substring(decimalIndex + 1);


      variantCent.innerHTML = '.'+digitsAfterDecimal;


      // convert to string
      let stringVariantPrice = globalProductVariantPrice.toString();

      // split the price starting from . and store in an array
      let intergerpart = stringVariantPrice.split('.');
      variantNewPrice.innerHTML = intergerpart[0];
    }

    if ((selectedVariant.compare_at_price / 100) % 1 === 0) {
      variantOldPrice.innerHTML = '$'+((selectedVariant.compare_at_price)/100).toFixed(0);

      globalProductOldPrice = ((selectedVariant.compare_at_price)/100).toFixed(0);
    
    }else{
      variantOldPrice.innerHTML = '$'+(((selectedVariant.compare_at_price)/100).toFixed(2));
      globalProductOldPrice = ((selectedVariant.compare_at_price)/100).toFixed(2);
    }

    // to display the saving price
    let overallPriceDiff = (globalProductOldPrice - globalProductVariantPrice)/4;
    $priceDiff.innerHTML = '$' + twoDigitDecimals(globalProductOldPrice - globalProductVariantPrice);
    //

    // to calculate the percentage off
    let getpercentOff = ((selectedVariant.compare_at_price - selectedVariant.price)/selectedVariant.compare_at_price) * 100;
    getpercentOff = getpercentOff.toString();
    let decimalPercent = getpercentOff.split('.');

    percentOff.forEach(el => {
      el.innerHTML = decimalPercent[0];
    })

    document.querySelector('.product_displaytag .toppercentoff .js-percent-off').innerHTML = decimalPercent[0];

    // update afterpay
    let $newafterpayPrice = selectedVariant.price/4;
    $afterpay.innerHTML = '$' + ((selectedVariant.price/4/100).toFixed(2));
    // twoDigitDecimals()
    // end afterpay

    let confirmationTitle = document.querySelector('.please_select_size .customerSelectedSize');
    confirmationTitle.innerHTML = selectedVariant.title;
}

function paypalContent(num){  
    if ((num/100) % 1 === 0) {
      return (num/4).toFixed(0);
    }else{
      return (num/4).toFixed(2);
    }
  }

function twoDigitDecimals(num){
// return formattedNumber;

  if ((num/100) % 1 === 0) {
    return (num).toFixed(0);
  }else{
    return (num).toFixed(2);
  }
}

// update input quantity value
let quantityPicker = document.querySelectorAll('.quantity-selector span.quantitybutton');
let input = document.querySelector('.quantity-selector input.quantity__input');
quantityPicker.forEach(qp => {
    qp.addEventListener('click', function(e) {
        e.preventDefault();

        if (this.classList.contains("quantity_minus")) {
            if (input.value > input.min) {
                input.value = parseInt(input.value) - 1;
            }
            if (input.value <= input.min) {
                this.setAttribute("disabled", true);
            }else{
                this.removeAttribute("disabled");
            }

            this.closest('.quantity-selector').querySelector('.quantity_plus').removeAttribute("disabled");

        }else if (this.classList.contains("quantity_plus")) {
            if (parseInt(input.value) < parseInt(input.max)) {
              input.value = parseInt(input.value) + 1;
            }

            if (parseInt(input.value) >= parseInt(input.max)) {
              this.setAttribute("disabled", true);
            }

            this.closest('.quantity-selector').querySelector('.quantity_minus').removeAttribute("disabled");
        }

    })
})
// end

// to have opacity after some seconds
setTimeout(() => {
    document.querySelector(".product__image-thumbnail").style.opacity = 1;
}, 500);

setTimeout(() => {
    let flickityButtons = document.querySelectorAll('.flickity-button');
    flickityButtons.forEach(button => {
        button.style.opacity = 1;
    });
}, 100);

// to add the loading class in the ATC button while clicking on it
let productATCBtn = document.querySelector('.product-action .add_btn');
productATCBtn.addEventListener('click', function(e) {
  let loadingButtonEl = this.querySelector('.custom-loading');
  loadingButtonEl.classList.remove('hidden');

  // check if the product has been updated to the side cart
  fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      // check if the product is in the cart
      setTimeout(() => {
        loadingButtonEl.classList.add('hidden');  
      }, 600);
      
    })

})

let cartSection = document.querySelector('.drawer .js-contents');

const ajaxify = {
    onAddToCart: function(event) {
      event.preventDefault();
      
      const formData = new FormData(document.querySelector('.product_mainform'));

      if (this.classList.contains('yes')) {
        this.closest('.please_select_size').style.display = 'none';
        // document.querySelector('.global_quantity_selector .add-to-cart').classList.add('loadingAnimation');
        document.querySelector('.add-to-cart button.addToCartBtn').classList.remove('js-disabled-add-to-cart');
        document.querySelector('.add-to-cart button.addToCartBtn').click();

        setTimeout(() => {
          document.querySelector('.add-to-cart button.addToCartBtn').classList.add('js-disabled-add-to-cart');
        }, 400);
      }
    
    },
  
    onCartUpdated: function(cart) {
      fetch('/cart', {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          return response.text();
        })
        .then(html => {
            // Replace the cart section with the updated HTML
            let tempDiv = document.createElement('div');

            tempDiv.innerHTML = html

            // for cart bage items
            let cartItems = tempDiv.querySelector('.header #cart-icon-bubble');
            // end

            let cartContents = tempDiv.querySelector('.js-contents');

            $('.drawer__contents').html(cartContents);
            $('#CartDrawer-CartErrors').html('');
            $('.drawer').removeClass('is-empty');
            $('.drawer__inner-empty').hide();
            $('cart-drawer-items').removeClass();
            $('#CartDrawer-Checkout').attr('disabled' , false);

            $.getJSON("/cart.js", function(cart) {
            // Shopify.getCart(function(cart) {  
              // top upate the cart items
              $('.header #cart-icon-bubble').html(cartItems);

              // remove loading animation
              document.querySelector('.global_quantity_selector .add-to-cart').classList.remove('loadingAnimation');
              // end

              let itemSubtoTotalPrice = cart.items_subtotal_price;
              if ((itemSubtoTotalPrice / 100) % 1 === 0) {
                itemSubtoTotalPrice = ((itemSubtoTotalPrice)/100).toFixed(0);
              }else{
                itemSubtoTotalPrice = itemSubtoTotalPrice / 100;
              }

              $(' cart-drawer p.totals__subtotal-value').html('$'+addCommas(itemSubtoTotalPrice)+' AUD');

              // to update shipping status
              if (parseInt(itemSubtoTotalPrice) >= 150) {
                $(' cart-drawer .shippingstatus').html('Free');
              }else{
                $(' cart-drawer .shippingstatus').html('$9.95');
              }
              // end

            });

            cartSection.innerHTML = cartContents.innerHTML;         
            document.getElementsByClassName('drawer')[0].classList.add('active');
            // $('body').css('overflow','hidden');
        })
        .catch(error => {
          ajaxify.onError(error);
        });
    },
  
    onError: function(error) {
      alert(error);
    },
  
    init: function() {
      // document.querySelector('.product-action button.addToCartBtn').addEventListener('click', ajaxify.onAddToCart);
      document.querySelector('.confirm_select_size button.yes').addEventListener('click', ajaxify.onAddToCart);
    }
  };

function addCommas(num) {
  // Convert the number to a string
  var str = num.toString();
  
  // Split the string into two parts: the integer part and the decimal part
  var parts = str.split('.');
  var integerPart = parts[0];
  var decimalPart = parts.length > 1 ? '.' + parts[1] : '';
  
  // Split the integer part into an array of digits
  var digits = integerPart.split('');
  
  // Reverse the array of digits
  digits.reverse();
  
  // Create an empty array to hold the new string
  var newStr = [];
  
  // Loop through the array of digits
  for (var i = 0; i < digits.length; i++) {
    // Add a comma every three digits
    if (i % 3 === 0 && i !== 0) {
      newStr.push(',');
    }
    // Add the current digit to the new array
    newStr.push(digits[i]);
  }
  
  // Reverse the array again and join the digits into a string
  var finalStr = newStr.reverse().join('');
  
  // Add the decimal part back to the string
  finalStr += decimalPart;
  
  // Return the final string
  return finalStr;
}

  
  ajaxify.init();
  // revy upsell
  // window.Shopify.ajaxify = ajaxify;
  // end




  function confirmMessage(){
    // Get all buttons with class "js-disabled-add-to-cart"
    const buttons = document.querySelectorAll("button.js-disabled-add-to-cart");
    
    // Add a click event listener to each button
    buttons.forEach(function(button) {
      button.addEventListener("click", function(event) {
        event.preventDefault();
    
        // Set the color of all buttons with class "js-add-to-cart-button" to white
        const addButtons = document.querySelectorAll('.add_btn button.js-add-to-cart-button');
        addButtons.forEach(function(addButton) {
          addButton.style.color = 'white';
        });
    
        // Get the closest form element to the clicked button
        const formTag = button.closest('form');
    
        // Display the element with class "please_select_size"
        const displaySelectMsg = document.querySelector('.please_select_size');
        displaySelectMsg.style.display = 'block';
      });
    }); 
  }


  let confirmNoBtn = document.querySelector('.confirm_select_size button.no');
  let confirmYesBtn = document.querySelector('.confirm_select_size button.yes');

  confirmNoBtn.addEventListener("click", function(e) {
    e.preventDefault();
    this.closest('.please_select_size').style.display = 'none';
  }); 


// jump to the review section while clicking on the top review section
  let topReviewSection = document.querySelectorAll('.jumpsection a.mainproductreviews')

  topReviewSection.forEach(element => {
    element.addEventListener('click', function(e){
      e.preventDefault();
      console.log('Review icon clicked beneath product title')

      // to find if the product template is design or compact template
      let getProductTemplate = this.closest('body');
      if (getProductTemplate.classList.contains('compact')) {
        let compactReviewSection = document.querySelector('body.compact .product_dropdown h2#title-r');
        let compactReviewSectionParent = compactReviewSection.closest('.content_block');
        
        compactReviewSectionParent.classList.add('active');

        openProductReview();

      }else{
        let reivewTab = document.querySelector('.product_dropdown .titles .title.review');
        reivewTab.click();
        openProductReview();
      }
      // end

    })
  });

  function openProductReview() {
    let targetDiv = document.querySelector('.newbottomreview');
    
    setTimeout(() => {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 200); // 500 ms timeout to allow images to load
  }
// end 

function zoom(e) {
  let windowSize = window.innerWidth;

  if (windowSize > 992) {
    var zoomer = e.currentTarget;
    var offsetX, offsetY;

    if (e.type === 'touchmove') {
        offsetX = e.touches[0].pageX;
        offsetY = e.touches[0].pageY;
    } else {
        offsetX = e.offsetX || e.clientX - zoomer.getBoundingClientRect().left;
        offsetY = e.offsetY || e.clientY - zoomer.getBoundingClientRect().top;
    }

    var x = offsetX / zoomer.offsetWidth * 100;
    var y = offsetY / zoomer.offsetHeight * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }
}

document.addEventListener("DOMContentLoaded", function() {

  let imgContainer = document.querySelectorAll('.img_producto_container');

  imgContainer.forEach(function(container) {
    let imgUrl = container.getAttribute('data-img');
    if (imgUrl) {
      container.style.backgroundImage = 'url(' + imgUrl + ')';
      container.addEventListener('mousemove', function(e) {
        zoom(e);
        container.querySelector('img.zoomimg').style.opacity = 0;
      });
      container.addEventListener('mouseleave', function() {
        container.querySelector('img.zoomimg').style.opacity = 1;
      });
    }
  });

  // product descripton tab to hide and show description based on the click on the product tab
  const titles = document.querySelectorAll('.product-description-tab .title');
  const texts = document.querySelectorAll('.text');

  titles.forEach(title => {
    title.addEventListener('click', function() {

      if (this.classList.contains('help')){
        return;
      }
      
      const id = this.id.split('-')[1];
      console.log(id);
      
      texts.forEach(text => {
        if(text.id === `text-${id}`) {
          text.style.display = 'block';
        } else {
          text.style.display = 'none';
        }
      });

      titles.forEach(title => title.classList.remove('title-active'));
      this.classList.add('title-active');

    });
  });

  function jumpReview(){
    console.log('jump to the review section');
    
    let targetDiv = document.querySelector('.updated.newbottomreview');
    setTimeout(() => {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  }
  // end of product description tab to hide and show description based on the click on the product tab

  // 

  
  const pf = document.querySelector('#__pf');

  if(pf){
    const productBottom = document.querySelector('.product-description-tab .product-description');
    productBottom.appendChild(pf);
  }

});